import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/Home",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */ "../views/Home"),
  },
  {
    path: "/",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "../common/Login"),
    meta: { hideNavigation: true }
  },
  {
    path: "/Register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../common/Register"),
    // meta: { hideMenu: true}
  },
  {
    path: "/Reset",
    name: "Reset",
    component: () => import(/* webpackChunkName: "Reset" */ "../common/Reset"),
    // meta: { hideMenu: true}
  },
  {
    path: "/Account",
    name: "Account",
    component: () =>
      import(/* webpackChunkName: "Account" */ "../views/Account"),
    meta: { requiresAuth: true },
  },
  {
    path: "/EditDetails",
    name: "EditDetails",
    component: () =>
      import(/* webpackChunkName: "EditDetails" */ "../views/EditDetails"),
  },
  {
    path: "/Videos",
    name: "Videos",
    component: () =>
      import(/* webpackChunkName: "Videos" */ "../views/Videos"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ShowVideo/:id,:platform",
    name: "ShowVideo",
    component: () =>
      import( /* webpackChunkName: "showVideo" */ "../views/showVideo"),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: "/Drills",
    name: "Drills",
    component: () =>
      import(/* webpackChunkName: "Drills" */ "../views/Drills"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Accreditation",
    name: "Accreditation",
    component: () =>
      import(/* webpackChunkName: "Accreditation" */ "../views/Accreditation"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Pathway",
    name: "Pathway",
    component: () =>
      import(/* webpackChunkName: "Pathway" */ "../views/Pathway"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Bookings",
    name: "Bookings",
    component: () =>
      import(/* webpackChunkName: "Bookings" */ "../views/Bookings"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Feedback",
    name: "Feedback",
    component: () =>
      import(/* webpackChunkName: "Feedback" */ "../views/Feedback"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Certificates",
    name: "Certificates",
    component: () =>
      import(/* webpackChunkName: "Certificates" */ "../views/Certificates"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Calendar",
    name: "Calendar",
    component: () =>
      import(/* webpackChunkName: "Calendar" */ "../views/Calendar"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Courses",
    name: "Courses",
    component: () =>
      import(/* webpackChunkName: "Courses" */ "../views/Courses"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Progress",
    name: "Progress",
    component: () =>
      import(/* webpackChunkName: "Progress" */ "../views/Progress"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Documents",
    name: "Documents",
    component: () =>
      import(/* webpackChunkName: "Documents" */ "../views/Documents"),
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/Documents/:Type?",
  //   name: "Documents",
  //   component: () =>
  //     import(/* webpackChunkName: "Documents" */ "../views/Documents"),
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/Help",
    name: "Help",
    component: () =>
      import(/* webpackChunkName: "Help" */ "../views/Help"),
  },
  {
    path: "/About",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "About" */ "../views/About"),
    meta: { requiresAuth: true },
  },
  {
    path: "/MyAssoc",
    name: "My Association",
    component: () =>
      import(/* webpackChunkName: "My Association" */ "../views/MyAssoc"),
    meta: { requiresAuth: true },
  },
  {
    path: "/People",
    name: "People",
    component: () =>
      import(/* webpackChunkName: "Help" */ "../views/People"),
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = !!localStorage.getItem("Coach");
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!loggedIn) {
      Vue.$toast.error(`You must be logged in to access this menu item !`, {
        timeout: 2000,
      });
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;